// @ts-nocheck
/**
 * SMS Webhook instruction card — displays the priority-1 admin note for
 * the SMS_WEBHOOK module.
 */
import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { fetchAndSetFlashMessage } from '@/service/fetchFlashMessage';
import { MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT } from '@/utilities/constant';

const InstructionCard = () => {
  const [notes, setNotes] = useState<any[]>([]);

  useEffect(() => {
    fetchAndSetFlashMessage(
      (msg: any) =>
        msg.module_name === MODULE_ACL.SMS_WEBHOOK &&
        msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD &&
        msg.type === 'Note',
      setNotes,
    );
  }, []);

  const note = notes.find((n: any) => Number(n.priority) === 1)?.message ?? '';

  return (
    <Card className="h-full">
      <CardHeader className="text-sm font-semibold text-muted-foreground">
        Instructions
      </CardHeader>
      <CardContent style={{ overflowY: 'auto' }}>
        <pre className="whitespace-pre-wrap text-sm">
          <strong>Note: </strong>
          {note}
        </pre>
      </CardContent>
    </Card>
  );
};

export default InstructionCard;
